var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getPages.find(x => x.type == this.type))?_c('router-link',{class:_vm.css_class,attrs:{"to":_vm.slug}},[_vm._v(_vm._s(_vm.getPages.find(x => x.type == this.type).title))]):_c('router-link',{class:_vm.css_class,attrs:{"to":_vm.slug}},[_vm._v(_vm._s(_vm.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }